export const onAttemptHandler = (navigate, roleOfTheUser, classroomId, activeTab, selectedTopicId, selectedTest) => {
  const basePath = roleOfTheUser === "Student" ? "/student" : "";
  const attemptType = selectedTest?.type === "writing"
    ? "writingTestAttempt"
    : selectedTest?.type === "speaking"
      ? "speakingTestAttempt"
      : "testAttempt";
  navigate(
    `${basePath}/myClassrooms/${classroomId}/${activeTab}/${selectedTopicId}/test/${attemptType}/${
      selectedTest?._id
    }?activeTab=${activeTab}`
  );
};

export const onViewAllAttempts = (navigate, roleOfTheUser, classroomId, activeTab) => {
  navigate(
    `${
      roleOfTheUser === "Student" ? "/student" : ""
    }/myClassrooms/${classroomId}/${activeTab}/test/all-attempts`
  );
};

export const onViewAttempts = (navigate, roleOfTheUser, classroomId, activeTab, selectedTest) => {
  navigate(
    `${
      roleOfTheUser === "Student" ? "/student" : ""
    }/myClassrooms/${classroomId}/${activeTab}/test/attempt-results/${
      selectedTest?._id
    }`
  );
}; 